import React, { useState, useEffect } from 'react';
import { getClientes, createCliente, updateCliente, getFacturas } from '../services/api';

function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [facturas, setFacturas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalHistorial, setModalHistorial] = useState(false);
  const [clienteHistorial, setClienteHistorial] = useState(null);
  const [editando, setEditando] = useState(null);
  const [buscar, setBuscar] = useState('');
  const [form, setForm] = useState({ nombreCompleto: '', telefono: '', direccion: '', ciudad: '', estado: '', pais: 'USA' });
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    Promise.all([
      getClientes(),
      getFacturas(1, 1000)
    ]).then(([cRes, fRes]) => {
      setClientes(cRes.data);
      setFacturas(fRes.data.data || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  const abrirHistorial = (c) => {
    setClienteHistorial(c);
    setModalHistorial(true);
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ nombreCompleto: '', telefono: '', direccion: '', ciudad: '', estado: '', pais: 'USA' });
    setError(''); setModal(true);
  };

  const abrirEditar = (c) => {
    setEditando(c);
    setForm({ nombreCompleto: c.nombreCompleto, telefono: c.telefono, direccion: c.direccion, ciudad: c.ciudad, estado: c.estado || '', pais: c.pais });
    setError(''); setModal(true);
  };

  const guardar = async () => {
    if (!form.nombreCompleto) { setError('El nombre es requerido'); return; }
    try {
      if (editando) await updateCliente(editando.id, form);
      else await createCliente(form);
      setModal(false); cargar();
    } catch { setError('Error al guardar. Intenta nuevamente.'); }
  };

  const filtrados = clientes.filter(c =>
    c.nombreCompleto?.toLowerCase().includes(buscar.toLowerCase()) ||
    c.telefono?.includes(buscar)
  );

  // Obtener facturas del cliente seleccionado
  const getFacturasCliente = (cliente) => {
    if (!cliente) return [];
    return facturas.filter(f =>
      f.remNombre?.toLowerCase() === cliente.nombreCompleto?.toLowerCase() ||
      f.desNombre?.toLowerCase() === cliente.nombreCompleto?.toLowerCase()
    );
  };

  const fmt = (monto, moneda) => {
    if (moneda === 'DOP') return `RD$${Number(monto).toLocaleString('es-DO', { minimumFractionDigits: 2 })}`;
    return `$${Number(monto).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
  };

  const getTotal = (f) => f.detalles?.reduce((s, d) => s + d.total, 0) || 0;
  const getPagado = (f) => (f.pagos?.reduce((s, p) => s + p.monto, 0) || 0) + (f.deposito || 0);

  const badgeStyle = (estado) => {
    const map = {
      'Pendiente': { bg: '#fef3c7', color: '#d97706' },
      'Abono Parcial': { bg: '#dbeafe', color: '#1d4ed8' },
      'Pagada': { bg: '#dcfce7', color: '#16a34a' },
      'Anulada': { bg: '#fee2e2', color: '#cc0000' },
    };
    const s = map[estado] || { bg: '#f1f5f9', color: '#64748b' };
    return { background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 600 };
  };

  const inp = (field, placeholder, type = 'text') => (
    <input type={type} placeholder={placeholder} value={form[field]}
      onChange={e => setForm({ ...form, [field]: e.target.value })}
      style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }} />
  );

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>Cargando...</div>;

  const facturasCliente = getFacturasCliente(clienteHistorial);
  const totalFacturado = facturasCliente.filter(f => !f.anulada).reduce((s, f) => s + getTotal(f), 0);
  const totalPagado = facturasCliente.filter(f => !f.anulada).reduce((s, f) => s + getPagado(f), 0);
  const totalBalance = totalFacturado - totalPagado;

  return (
    <div>
      {/* Filtros */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 18 }}>
        <input placeholder="Buscar cliente..." value={buscar} onChange={e => setBuscar(e.target.value)}
          style={{ padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', outline: 'none', flex: 1 }} />
      </div>

      <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Clientes ({filtrados.length})</h3>
          <button onClick={abrirNuevo} style={{ padding: '8px 16px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>+ Nuevo Cliente</button>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Nombre', 'Teléfono', 'Ciudad', 'País', 'Acciones'].map(h => (
                  <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrados.length === 0 ? (
                <tr><td colSpan={5} style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>No hay clientes</td></tr>
              ) : filtrados.map(c => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '13px 16px', fontSize: 14, fontWeight: 600 }}>{c.nombreCompleto}</td>
                  <td style={{ padding: '13px 16px', fontSize: 14 }}>{c.telefono}</td>
                  <td style={{ padding: '13px 16px', fontSize: 14 }}>{c.ciudad}</td>
                  <td style={{ padding: '13px 16px' }}>
                    <span style={{ background: c.pais === 'USA' ? '#dbeafe' : '#dcfce7', color: c.pais === 'USA' ? '#0d2461' : '#16a34a', padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 600 }}>{c.pais}</span>
                  </td>
                  <td style={{ padding: '13px 16px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => abrirHistorial(c)} style={{ padding: '6px 12px', background: '#dbeafe', color: '#0d2461', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>📋 Historial</button>
                      <button onClick={() => abrirEditar(c)} style={{ padding: '6px 12px', background: '#f1f5f9', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>✏️ Editar</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal Historial */}
      {modalHistorial && clienteHistorial && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 500, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 20px', overflowY: 'auto' }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 800, boxShadow: '0 25px 50px rgba(0,0,0,0.25)', margin: 'auto' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#0d2461' }}>📋 Historial — {clienteHistorial.nombreCompleto}</h2>
                <div style={{ fontSize: 13, color: '#64748b', marginTop: 3 }}>{clienteHistorial.telefono} · {clienteHistorial.ciudad} · {clienteHistorial.pais}</div>
              </div>
              <button onClick={() => setModalHistorial(false)} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#94a3b8' }}>×</button>
            </div>

            {/* Resumen */}
            <div style={{ padding: '16px 24px', borderBottom: '1px solid #e2e8f0' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 12 }}>
                {[
                  { label: 'Total Facturas', value: facturasCliente.length, color: '#0d2461' },
                  { label: 'Total Facturado', value: `$${totalFacturado.toFixed(2)}`, color: '#0d2461' },
                  { label: 'Total Pagado', value: `$${totalPagado.toFixed(2)}`, color: '#16a34a' },
                  { label: 'Balance Pendiente', value: `$${totalBalance.toFixed(2)}`, color: totalBalance > 0 ? '#cc0000' : '#16a34a' },
                ].map(({ label, value, color }) => (
                  <div key={label} style={{ background: '#f8fafc', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
                    <div style={{ fontSize: 11, color: '#64748b', fontWeight: 500, textTransform: 'uppercase' }}>{label}</div>
                    <div style={{ fontSize: 20, fontWeight: 700, color, margin: '4px 0' }}>{value}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Facturas */}
            <div style={{ padding: 24, maxHeight: '50vh', overflowY: 'auto' }}>
              {facturasCliente.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>Este cliente no tiene facturas registradas</div>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      {['Factura', 'Fecha', 'Rol', 'Furgón', 'Total', 'Pagado', 'Balance', 'Estado'].map(h => (
                        <th key={h} style={{ padding: '9px 12px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {facturasCliente.map(f => {
                      const total = getTotal(f);
                      const pagado = getPagado(f);
                      const balance = total - pagado;
                      const rol = f.remNombre?.toLowerCase() === clienteHistorial.nombreCompleto?.toLowerCase() ? 'Remitente' : 'Destinatario';
                      return (
                        <tr key={f.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                          <td style={{ padding: '10px 12px', fontFamily: 'monospace', fontWeight: 600, fontSize: 13 }}>{f.numero}</td>
                          <td style={{ padding: '10px 12px', fontSize: 12, color: '#64748b' }}>{new Date(f.fechaCreacion).toLocaleDateString('es-DO')}</td>
                          <td style={{ padding: '10px 12px' }}>
                            <span style={{ background: rol === 'Remitente' ? '#dbeafe' : '#dcfce7', color: rol === 'Remitente' ? '#0d2461' : '#16a34a', padding: '2px 8px', borderRadius: 100, fontSize: 11, fontWeight: 600 }}>{rol}</span>
                          </td>
                          <td style={{ padding: '10px 12px' }}><span style={{ background: '#dbeafe', color: '#0d2461', padding: '2px 8px', borderRadius: 100, fontSize: 11, fontWeight: 600 }}>#{f.furgonNumero}</span></td>
                          <td style={{ padding: '10px 12px', fontSize: 13, fontWeight: 600 }}>{fmt(total, f.moneda)}</td>
                          <td style={{ padding: '10px 12px', fontSize: 13, color: '#16a34a', fontWeight: 600 }}>{fmt(pagado, f.moneda)}</td>
                          <td style={{ padding: '10px 12px', fontSize: 13, fontWeight: 600, color: balance > 0 ? '#cc0000' : '#16a34a' }}>{fmt(balance, f.moneda)}</td>
                          <td style={{ padding: '10px 12px' }}><span style={badgeStyle(f.estadoPago)}>{f.estadoPago}</span></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Crear/Editar */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 520, boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#0d2461' }}>{editando ? 'Editar Cliente' : 'Nuevo Cliente'}</h2>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#94a3b8' }}>×</button>
            </div>
            <div style={{ padding: 24 }}>
              {error && <div style={{ background: '#fee2e2', color: '#cc0000', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>⚠️ {error}</div>}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div><label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Nombre Completo</label><div style={{ marginTop: 5 }}>{inp('nombreCompleto', 'Nombre completo')}</div></div>
                <div><label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Teléfono</label><div style={{ marginTop: 5 }}>{inp('telefono', '(XXX) XXX-XXXX')}</div></div>
              </div>
              <div style={{ marginBottom: 12 }}><label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Dirección</label><div style={{ marginTop: 5 }}>{inp('direccion', 'Dirección')}</div></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
                <div><label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Ciudad</label><div style={{ marginTop: 5 }}>{inp('ciudad', 'Ciudad')}</div></div>
                <div><label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Estado</label><div style={{ marginTop: 5 }}>{inp('estado', 'FL')}</div></div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.04em' }}>País</label>
                  <select value={form.pais} onChange={e => setForm({ ...form, pais: e.target.value })}
                    style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none' }}>
                    <option>USA</option><option>República Dominicana</option><option>Otro</option>
                  </select>
                </div>
              </div>
            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <button onClick={() => setModal(false)} style={{ padding: '9px 18px', background: 'white', color: '#0d2461', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Cancelar</button>
              <button onClick={guardar} style={{ padding: '9px 18px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>💾 Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Clientes;